// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 962 ? "home" : chunkId) + "." + {"570":"8271d884","962":"0eb14928"}[chunkId] + ".css";
};